import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import Table from '../../common/Table';
import Select from '../../common/Select';
import { useDispatch } from 'react-redux';
import { fetchGetRegions } from '../../../actions/settings';
import InputWrapper from '../../common/InputWrapper';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const defaultRow = {
  country: 'RU',
  region: 'MOSCOW',
  extraFeeFixValue: 100,
  extraFeePercentValue: 0,
  enabled: false,
  tariffEnabled: true,
};

const getEnabledValue = (enabled, tariffEnabled) => {
  if (!tariffEnabled) return 2;
  return enabled ? 1 : 0;
};

const getSelectValue = (options, value) => options.find((option) => option.value === value);

const Wrapper = styled.div`
  .title {
    color: #98a6ad;
    font-weight: 500;
    font-size: 11px;
    margin-top: 16px;
    text-transform: uppercase;
  }

  .react-select-container {
    min-width: 190px;
  }

  .enabled-state-select {
    .react-select-container {
      min-width: 230px;
    }
  }

  .number-input {
    width: 93px;
  }

  .add-setting {
    cursor: pointer;
    color: #7e57c2;
    width: fit-content;
    position: relative;
    margin-top: 18px;
  }

  .table {
    margin-bottom: 0;
  }

  .table-responsive {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 400px;

    thead th {
      position: sticky;
      top: 0;
      z-index: 1;
    }
  }

  .border-block {
    border-bottom: 1px solid #dee2e6;
    margin: 0 -24px;
  }
`;

const DeliveryOptions = (props) => {
  const { deliveryRegionSettings, setDeliveryRegionSettings } = props;
  const dispatch = useDispatch();
  const [regions, setRegions] = useState([]);

  const { t } = useAutoTranslation();

  const countries = [
    { value: `ALL`, label: t(`Все страны`) },
    { value: `RU`, label: t(`Россия`) },
    { value: `SNG`, label: t(`СНГ`) },
    { value: `OTHER`, label: t(`Остальные страны`) },
    { value: `EAES`, label: t(`ЕАЭС`) },
  ];

  const enabledStates = [
    { value: 0, label: t(`Настройка выключена`) },
    { value: 1, label: t(`Активен`) },
    { value: 2, label: t(`Исключить из тарификации`) },
  ];

  useEffect(() => {
    dispatch(fetchGetRegions()).then((regions) => {
      setRegions(
        regions.map((region) => ({
          value: region.name,
          label: region.title === `All` ? `Все регионы` : region.title,
        })),
      );
    });
  }, [dispatch]);

  const setFieldValue = (index, key, value) => {
    const tmpValues = JSON.parse(JSON.stringify(deliveryRegionSettings));
    tmpValues[index][key] = value;
    setDeliveryRegionSettings(tmpValues);
  };

  const handleAddRow = () => {
    const tmpValues = JSON.parse(JSON.stringify(deliveryRegionSettings));
    tmpValues[deliveryRegionSettings.length] = defaultRow;
    setDeliveryRegionSettings(tmpValues);
  };

  const handleRemoveRow = (item, index) => {
    const tmpValues = JSON.parse(JSON.stringify(deliveryRegionSettings));
    tmpValues.splice(index, 1);
    setDeliveryRegionSettings(tmpValues);
  };

  const rows = deliveryRegionSettings.map((setting, index) => ({
    isRemovable: true,
    data: [
      {
        value: (
          <Select
            options={countries}
            value={getSelectValue(countries, deliveryRegionSettings[index].country)}
            onChange={(option) => setFieldValue(index, `country`, option.value)}
          />
        ),
      },
      {
        value: (
          <Select
            isDisabled={
              getSelectValue(countries, deliveryRegionSettings[index].country).value !== `RU`
            }
            options={regions}
            value={
              getSelectValue(countries, deliveryRegionSettings[index].country).value === `RU`
                ? getSelectValue(regions, deliveryRegionSettings[index].region)
                : { label: t(`Все регионы`), value: `ALL_REGIONS` }
            }
            onChange={(option) => setFieldValue(index, `region`, option.value)}
          />
        ),
      },
      {
        value: (
          <InputWrapper
            noLabel
            inputClassName="number-input form-control"
            value={deliveryRegionSettings[index].extraFeePercentValue}
            onChange={(evt) => setFieldValue(index, `extraFeePercentValue`, evt.target.value)}
          />
        ),
      },
      {
        value: (
          <InputWrapper
            noLabel
            inputClassName="number-input form-control"
            value={deliveryRegionSettings[index].extraFeeFixValue}
            onChange={(evt) => setFieldValue(index, `extraFeeFixValue`, evt.target.value)}
          />
        ),
      },
      {
        value: (
          <InputWrapper
            noLabel
            inputClassName="number-input form-control"
            value={deliveryRegionSettings[index].orderSumMoreThan}
            onChange={(evt) => {
              if (Number.isInteger(+evt.target.value))
                setFieldValue(index, `orderSumMoreThan`, evt.target.value);
            }}
          />
        ),
      },
      {
        value: (
          <div className="enabled-state-select">
            <Select
              options={enabledStates}
              value={getSelectValue(
                enabledStates,
                deliveryRegionSettings[index].enabledTmp === undefined
                  ? getEnabledValue(
                      deliveryRegionSettings[index].enabled,
                      deliveryRegionSettings[index].tariffEnabled,
                    )
                  : deliveryRegionSettings[index].enabledTmp,
              )}
              onChange={(option) => setFieldValue(index, `enabledTmp`, option.value)}
            />
          </div>
        ),
      },
    ],
  }));

  return (
    <Wrapper>
      <h4 className="title">{t('Настройки доставки')}</h4>
      <Table
        removable
        handleRemoveItem={handleRemoveRow}
        data={{
          cols: [
            t(`Страна`),
            t(`Регион`),
            t(`Наценка, %`),
            t(`Наценка, ₽`),
            t(`Сумма заказа более, ₽`),
            t(`Статус`),
          ],
          rows,
        }}
      />
      <p className="add-setting" onClick={handleAddRow}>
        {t('Добавить настройку')}
      </p>
      <div className="border-block" />
    </Wrapper>
  );
};

export default DeliveryOptions;
